import { CRMLayout, SupportersPageContent } from '@gik/crm';
import { useInkindStore } from '@gik/inkind/store/InkindStore';
import React from 'react';
import { useUserStore } from '@gik/core/store/UserStore';
import { isInkindPageOwnerOrOrganizer } from '@gik/inkind-page/utils/inkindPagePermissions';
import { navigateTo } from '@/utils/environment';
import { useInkind } from '@gik/api/inkinds/inkind';
import { LoadingSpinner, PageSection } from '@gik/ui';

export type SupportersPageProps = {
  inkindRouteId: string;
  forceEmptyView?: boolean;
};

export default function SupportersPage({ inkindRouteId, forceEmptyView }: SupportersPageProps) {
  const [loading, setLoading] = React.useState(true);

  const setInkindRouteId = useInkindStore(store => store.setInkindRouteId);
  setInkindRouteId(inkindRouteId);

  const { data: inkind } = useInkind(inkindRouteId);
  const [userId, userStoreIsReady] = useUserStore(state => [state.id, state.isReady]);
  const isOwnerOrOrganizer = isInkindPageOwnerOrOrganizer(inkind, userId);
  const inkindPageLoaded = !!inkind;

  React.useEffect(() => {
    if (inkindPageLoaded && userStoreIsReady) {
      if (!isOwnerOrOrganizer) {
        navigateTo(`/inkinds/${inkindRouteId}`);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(true);
    }
  }, [inkindRouteId, isOwnerOrOrganizer, inkindPageLoaded, userStoreIsReady]);

  return (
    <>
      {loading ? (
        <PageSection>
          <LoadingSpinner center />
        </PageSection>
      ) : (
        <CRMLayout>
          <SupportersPageContent forceEmptyView={forceEmptyView} />
        </CRMLayout>
      )}
    </>
  );
}
